/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';
import { queryString } from '@utils/format';

const opt = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_API_URL + '/psp/gtk',
};
let $ajax = kitsu(opt);

export const state = {
  monev: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {} },
  meta: {},
  mapel: {},
  akun: null,
  instrumen: null,
};

export const mutations = {
  SET_DETAIL(state, newValue) {
    let monev = {};

    for (const laporan of newValue) {
      monev[laporan.k_monev_laporan_psp] = laporan;
    }

    state.monev = monev;
  },
  SET_META(state, newValue) {
    state.meta = newValue;
  },
  SET_AKUN(state, newValue) {
    state.akun = Object.assign({}, state.akun, newValue);
  },
  SET_MAPEL(state, newValue) {
    state.mapel = Object.assign({}, state.mapel, newValue);
  },
  SET_INSTRUMEN(state, newValue) {
    state.instrumen = Object.assign({}, newValue);
  },
};

export const actions = {
  async fetch({ commit }, payloads) {
    if (state.monev && !payloads.reset) return Promise.resolve(state.monev);

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/monev`,
    });
    const detail = await $ajax.get(`/`, { params: payloads.params }).then((data) => data);

    commit('SET_DETAIL', detail?.data ?? []);
    commit('SET_META', detail?.meta ?? []);

    return Promise.resolve(detail);
  },

  async fetchInstrumen({ commit }) {
    if (state.instrumen) return Promise.resolve(state.instrumen);

    const { data } = await http.get(`psp/gtk/monev/instrumen`);

    commit('SET_INSTRUMEN', data);

    return Promise.resolve(data);
  },

  async fetchPartisipan({}, payloads) {
    const { data } = await http.get(`psp/gtk/monev/kandidat-ujian?${queryString(payloads.params)}`);

    return Promise.resolve(data);
  },

  async detail({}, payload) {
    const { data } = await http.get(`psp/gtk/monev/${payload.id}`);
    return Promise.resolve(data);
  },

  async akuns({ commit }, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/monev/akun-${payload.type}`,
    });

    const resp = await $ajax.get(`/`).then((data) => data);
    const akuns = resp?.data ?? [];

    let akun = {};
    akun[payload.type] = akuns.map((akun) => {
      return { text: akun.nama, value: akun.id };
    });

    commit(`SET_AKUN`, akun);
    return Promise.resolve(resp);
  },

  async mapels({ state, commit }, payloads) {
    if (state.mapel[payloads.id]) {
      return Promise.resolve(state.mapel[payloads.id]);
    }

    const { data } = await http.get(`psp/gtk/monev/mapel/${payloads.id}`);

    let mapel = {};
    mapel[payloads.id] = data;

    commit('SET_MAPEL', mapel);
    return Promise.resolve(data);
  },

  async cekPartisipan({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/monev`,
    });
    const { data } = await $ajax
      .get(`/${payload.id}/kandidat-partisipan`, { params: payload.params })
      .then((data) => data);

    return Promise.resolve(data);
  },

  uploadBerkas({}, payloads) {
    const url = `psp/gtk/monev/berkas-insert`;
    return http.post(url, payloads.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  actions({}, payload) {
    const url = `psp/gtk/monev${payload.id ? `/${payload.id}` : ''}/${payload.type}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  save({}, { id, params, type }) {
    let url = `psp/gtk/monev/${id ? `${id}/update` : 'create'}${type ? `-${type}` : ''}`;
    if (type === 'umum') {
      url = 'psp/gtk/monev/save';
    } else if (type === 'partisipan') {
      url = `psp/gtk/monev/${id}/update-partisipan`;
    } else if (type === 'evaluasi-pelaksanaan') {
      url = `psp/gtk/monev/update-pelaksanaan`;
    } else if (type === 'evaluasi-pip') {
      url = `psp/gtk/monev/update-pip`;
    } else if (type === 'update-ujian') {
      url = `psp/gtk/monev/update-ujian`;
    }

    return http.post(url, params);
  },
};
